import styled, { css } from 'styled-components';
import { Input } from 'antd';

export const StyledSearchInput = styled(Input.Search)`
    ${({ theme }) => css`
        width: 100%;
        max-width: 35rem;
        input {
            color: ${theme.colors.font};
        }
    `}
`;
